var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIkonaWiadomosc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10.267,
    viewBox: "0 0 14 10.267"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.026 1.05L7 4.697 1.975 1.05 1.307.565l-.614.736.43.314 5.338 3.873a.923.923 0 001.073 0l5.341-3.872.432-.314-.614-.736zm.849.566v7.6H1.125v-7.6l-.431-.314.614-.736.669.486h10.049l.668-.486.614.736zM13.5 0H.5a.484.484 0 00-.5.467V9.8a.485.485 0 00.5.467h13A.484.484 0 0014 9.8V.467A.483.483 0 0013.5 0z",
    fill: "#750b22"
  })));
}

export default SvgIkonaWiadomosc;